import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import { ITokens } from '@myStore/auth/auth.state';
import { Store } from '@ngrx/store';
import { AuthService } from '@services/auth/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _store: Store<IAppState>
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const accessToken = this._authService.getToken('access');

    if (!accessToken) {
      this._router.navigate(['/login']);
      return false;
    }

    if (accessToken) {
      if (this._authService.tokenIsExpiry(accessToken)) {
        return this._authService.refreshToken().pipe(
          map((userTokens: ITokens) => {
            this._authService.updateTokens(userTokens);
            return true;
          })
        );
      }
    }

    return true;
  }
}
